export function createArray<T>(value: any | T[]): T[] {
  return Array.isArray(value) ? [...value] : [];
}
